module.exports = __webpack_public_path__ + "img/access_denied.736ffd42.png";